
import { defineComponent, reactive, toRefs } from 'vue'
import txImg from '@/assets/tx.png'
import BlogList from '@/components/BlogList.vue'
import Aside from '@/components/Aside.vue'
import { useDelay, useLog, usePostRequest } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import BannerImg from '@/assets/engine.jpg'

export default defineComponent({
  name: 'Home',
  components: {
    BlogList,
    Aside,
  },
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const state = reactive({
      bannerBgImgUrl:
        'https://cdn.jsdelivr.net/gh/dateolive/Hi-Dream-BlogReSource@main/img/backgroundimg.jpg',
      protraitImgUrl: txImg,
      proberb: '以代码为镜，可通逻辑；以人本为镜，可明得失。',
      blogs: [],
      pagingParams: {
        pageSize: 5,
        currentPage: 1,
        total: 100,
      },
      isLoading: true,
      alertTimeout: useDelay(5000).isLoading,
    })

    const getBlogInfo = () => {
      state.isLoading = true
      // 初始化博客,传入BlogList组件
      usePostRequest('/api/blog', state.pagingParams)
        .then((res) => {
          AssertGoodResponse(res)
          state.blogs = res.data.data.collection
          state.pagingParams.pageSize = res.data.data.pageSize
          state.pagingParams.currentPage = res.data.data.currentPage
          state.pagingParams.total = res.data.data.total
          // l(`第${state.pagingParams.currentPage}页的数据:`, state.blogs)
        })
        .finally(() => {
          state.isLoading = false
        })
    }

    const currentPageChange = (newCurrentPage: number) => {
      state.pagingParams.currentPage = newCurrentPage
      getBlogInfo()
    }

    // BeforeCreate
    getBlogInfo()

    return {
      ...toRefs(state),
      currentPageChange,
      BannerImg
    }
  },
})
